import { Column } from '~components/table-view';

/**
 * The preview table's columns.
 *
 * `showMoved` is about DETECTION, not about the choice: the column appears whenever this run has
 * services changing contribution category, and stays there when a provider switches the move off.
 * Hiding it on the switch would take away the only per-budget account of what the switch is deciding
 * at the moment they decide it - and a column that disappears reads as data that has gone away.
 */
const buildColumns = (showMoved: boolean): Column[] => [
  {
    id: 'client_name',
    header: 'Client Name',
    type: 'text',
  },
  {
    id: 'ref',
    header: 'Reference',
    type: 'text',
  },
  {
    id: 'package',
    header: 'Package',
    type: 'text',
  },
  {
    id: 'funding_type',
    header: 'Funding Type',
    type: 'text',
  },
  {
    id: 'removed_count',
    header: 'Services Removed',
    type: 'text',
  },
  // Which services, and where they are going, is stated once in the notice above the table rather
  // than repeated on every row - the change is the same one for every budget in the run.
  ...(showMoved
    ? [
        {
          id: 'moved_count',
          header: 'Services Moved',
          type: 'text',
        } as Column,
      ]
    : []),
  {
    id: 'price_missing_count',
    header: 'Price Missing',
    type: 'text',
  },
];

export default buildColumns;
